import apiRequest from "../../../../utils/ApiRequest/apiRequest";
import getSharedMailParamsFromUrl from "../helpers/getSharedMailParamsFromUrl";

import { useContent } from "contexts/contentContext/contentContext";
import { useEffect } from "react";

/**
 * Gets params from the URL and doing request,
 */
const useSharedMailLink = () => {
  const { getLanguage } = useContent();

  const redirectToGallery = async (
    payload: ReturnType<typeof getSharedMailParamsFromUrl>
  ) => {
    const response = await apiRequest("Mails", "RedirectToGallery", payload);

    const stringResponse = response.data + "";

    const linkToRedirect = stringResponse.includes("rror")
      ? `/${getLanguage()}/error`
      : stringResponse;

    window.location.href = linkToRedirect;
  };

  useEffect(() => {
    const sharedMailData = getSharedMailParamsFromUrl();

    redirectToGallery(sharedMailData);
  }, []);
};

export default useSharedMailLink;
